export enum SearchResultsBlock {
  Root = 'SearchResults',
}

export enum SearchResultsElement {
  Title = 'title',
  SearchValue = 'searchValue',
}
